import { render, staticRenderFns } from "./HousingHelp.vue?vue&type=template&id=dda59bec&"
import script from "./HousingHelp.vue?vue&type=script&lang=js&"
export * from "./HousingHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports